import React, { Component } from "react";
import moment from "moment";
import "moment/locale/pt-br";

import { Button, ProgressBar } from "react-bootstrap";
import { render } from "react-dom";
import { object } from "prop-types";
import _ from "lodash";
import classNames from "classnames";
import axios from "axios";
import config from "../../config";
// c3
import C3Chart from "react-c3js";
import "c3/c3.css";

class Cohort extends Component {
  constructor(props) {
    super(props);
    // http://localhost:3003/videos/5b6d8bf39d77b90006b577c7/cohort.html?start_date=2018-09-25&end_date=2018-09-26
  }

  render() {
    return (
      <div>
        <div style={{ textAlign: "center" }}>
          <a
            href={`${config.trackingReportUrl}/videos/${this.props.video.id}/cohort.html?start_date=${moment(
              this.props.timeframe.start
            ).format("YYYY-MM-DD")}&end_date=start_date=${moment(this.props.timeframe.end).format("YYYY-MM-DD")}`}
            className="btn btn-lg btn-primary"
            target="_blank"
          >
            Abrir Cohort em uma nova janela
          </a>
        </div>
      </div>
    );
  }
}

Cohort.propTypes = {
  timeframe: object,
  campaign: object
};

export default Cohort;



// WEBPACK FOOTER //
// ./src/components/charts/Cohort.js